export const blockIconsEditorMode = (
	<span className='material-symbols-outlined'>mode</span>
);
